module.exports = __webpack_public_path__ + "img/moscow_description.df17fe97.png";